// extracted by mini-css-extract-plugin
export var container = "_5k-1";
export var cornerButtonContainer = "_5k-6";
export var disabled = "_5k-2";
export var dragActive = "_5k-3";
export var fileContainer = "_5k-5";
export var hiddenInput = "_5k-4";
export var widthContainer = "_5k-0";